// extracted by mini-css-extract-plugin
export default {"infosRole":"Infos_infosRole__UYfte"};